/**
 * Saga slotaanbod — CTA scroll to the product form.
 *
 * This theme has no existing smooth-scroll convention to reuse (checked):
 * every anchor jump elsewhere in it is instant, and the one "smooth"
 * pattern that does exist is scrollIntoView, which this button explicitly
 * avoids. This is a small, self-contained window.scrollTo instead — finds
 * the real product form by its existing selector rather than a hardcoded
 * anchor id, so it keeps working regardless of which section renders the
 * form or what id that section happens to generate.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-saga-slot-cta]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return; // no fallback needed: href="#" just does nothing without JS
      event.preventDefault();
      const top = form.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
});
